import { type JSONConfig, ViewPortKind } from '@/engine/app/interfaces.ts';

export const axial: JSONConfig.ViewPort = {
  descriptor: 'axialView',
  kind: ViewPortKind.ImageSlice,
  details: {
    sliceDescriptor: 'AXIAL'
  }
};

export const coronal: JSONConfig.ViewPort = {
  descriptor: 'coronalView',
  kind: ViewPortKind.ImageSlice,
  details: {
    sliceDescriptor: 'CORONAL'
  }
};

export const sagittal: JSONConfig.ViewPort = {
  descriptor: 'sagittalView',
  kind: ViewPortKind.ImageSlice,
  details: {
    sliceDescriptor: 'SAGITTAL'
  }
};

export const threeD: JSONConfig.ViewPort = {
  descriptor: '3dView',
  kind: ViewPortKind.ThreeD,
  details: {
    defaultOrientationDescriptor: 'FRONT',
    frontOrientationDescriptor: ''
  }
};
